import { IBacklogContextData } from "Agile/Scripts/Common/Agile";
import { ExceptionInfo } from "Agile/Scripts/Models/ExceptionInfo";
import { IProductBacklogQueryResult } from "Agile/Scripts/ProductBacklog/ProductBacklogContracts";
import { ISprintCapacityData } from "Agile/Scripts/SprintsHub/Common/CommonContracts";
import { IColumnPreference } from "Agile/Scripts/ProductBacklog/ProductBacklogContracts";

/**
 * Data contract for the SprintsHubBacklogDataProvider
 */
export interface ISprintBacklogPivotData {
    /** The backlog context data */
    backlogContext: IBacklogContextData;

    /**
     * The backlog grid data
     * Contains rows, columns, and product backlog grid options
     */
    backlogQueryResults: IProductBacklogQueryResult;

    /**
     * Column preferences from user settings.
     */
    columnPreferences: IColumnPreference[];

    /** The initial filter */
    initialBacklogFilterJson: string;

    /**
     * Server exception information.
     */
    exceptionInfo: ExceptionInfo;

    /** Active work item types */
    activeWorkItemTypes: string[];
}

export interface ISprintBacklogInitialPayload {

    backlogContentData: ISprintBacklogPivotData;
    capacityData: ISprintCapacityData;
}